export default "__VITE_ASSET__TQpW1IEC__"